import { cn } from '../lib/utils';
import Select from '../ui/select';

import { SPACES, type SpaceId } from './spaces';

const SPACE_OPTIONS = SPACES.map((s) => ({
  value: s.id,
  label: `${s.name} · ${s.zone} (${s.seats} desks)`,
}));

/**
 * The floor picker. `SeatMap` draws it above the canvas when `showPicker` is
 * on; a page that wants it somewhere else turns that off and places this
 * itself, so the canvas can start level with whatever sits beside the map.
 *
 * Drawn like the client's FilterDropdown: mono label above, the input box at
 * the 36px filter height, so it matches the filters on the list pages.
 */
export default function SpacePicker({
  value,
  onChange,
  fill = false,
  className,
}: {
  value: SpaceId;
  onChange: (space: SpaceId) => void;
  /**
   * Take the width the page gives it, however narrow, and cut the name short
   * with an ellipsis: for a row it shares with other controls on a phone.
   */
  fill?: boolean;
  className?: string;
}) {
  return (
    // `items-start`, or the column stretches the box to whatever width the
    // page gives it rather than to its own value. Unless that is the point.
    <div
      className={cn('flex flex-col gap-1.5', fill ? 'min-w-0' : 'items-start', className)}
    >
      <span aria-hidden="true" className="font-mono text-2xs text-ink-muted uppercase">
        Space
      </span>
      <Select
        variant="field"
        aria-label="Space"
        className={cn('text-sm', fill ? 'w-full min-w-0' : 'w-auto min-w-45')}
        value={value}
        onChange={(next) => onChange(next as SpaceId)}
        options={SPACE_OPTIONS}
      />
    </div>
  );
}
